import { MODEL_FAMILIES } from './ModelFamilies';

export interface ModelConfiguration {
  max_input_length: number;
  new_tokens_max: number;
  prompt_template_tokens: number;
  chat_pair_tokens: number;
  eos_token: string[];
}

export const MODEL_CONFIGURATIONS: Record<MODEL_FAMILIES, ModelConfiguration> =
  {
    [MODEL_FAMILIES.LLAMA_3_2]: {
      max_input_length: 66048,
      new_tokens_max: 22016,
      prompt_template_tokens: 330,
      chat_pair_tokens: 34,
      eos_token: ['<|eot_id|>', '<|end_of_text|>'],
    },
    [MODEL_FAMILIES.GEMMA_3]: {
      max_input_length: 66048,
      new_tokens_max: 22016,
      prompt_template_tokens: 330,
      chat_pair_tokens: 34,
      eos_token: ['<end_of_turn>', '<eos>'],
    },
    [MODEL_FAMILIES.QWEN_3VL]: {
      max_input_length: 196608,
      new_tokens_max: 65535,
      prompt_template_tokens: 105,
      chat_pair_tokens: 34,
      eos_token: ['<|im_end|>', '<|endoftext|>'],
    },
    [MODEL_FAMILIES.QWEN_3_5]: {
      max_input_length: 196608,
      new_tokens_max: 65535,
      prompt_template_tokens: 105,
      chat_pair_tokens: 34,
      eos_token: ['<|im_end|>', '<|endoftext|>'],
    },
    [MODEL_FAMILIES.GLM_4_6V]: {
      max_input_length: 98304,
      new_tokens_max: 32768,
      prompt_template_tokens: 105,
      chat_pair_tokens: 34,
      eos_token: ['<|endoftext|>'],
    },
    [MODEL_FAMILIES.MINISTRAL_3]: {
      max_input_length: 196608,
      new_tokens_max: 65535,
      prompt_template_tokens: 105,
      chat_pair_tokens: 34,
      eos_token: ['</s>'],
    },
    [MODEL_FAMILIES.GEMMA_4]: {
      max_input_length: 98304,
      new_tokens_max: 32768,
      prompt_template_tokens: 330,
      chat_pair_tokens: 34,
      eos_token: ['<turn|>', '<eos>'],
    },
  };
